import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Tabs, Tab, Box,
} from '@material-ui/core';
import useStyles from './styles';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;
  const classes = useStyles();

  return (
    <div
      className={classes.tabPanel}
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={classes.box}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

TabPanel.defaultProps = {
  children: null,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const Training = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  return (
    <main className={classes.container}>
      <Tabs
        classes={{ root: classes.tabs, indicator: classes.indicator }}
        value={activeTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="off"
        aria-label="scrollable auto tabs example"
      >
        <Tab
          classes={{ root: classes.tab, selected: classes.selected }}
          disableRipple
          label={t('training.basic')}
          {...a11yProps(0)}
        />
        <Tab
          classes={{ root: classes.tab, selected: classes.selected }}
          disableRipple
          label={t('training.instructor')}
          {...a11yProps(1)}
        />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        {t('training.basic')}
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        {t('training.instructor')}
      </TabPanel>
    </main>
  );
};

export default Training;
